import React, { useEffect } from "react";
import { useIntl } from 'react-intl';

// Components
import Select from 'Components/Select';
import { Form } from 'Components';

// Helpers
import { OrderData } from 'Core/data/Helpers';

export const RouteWatchers = (props) => {

    const { value, onChange, formRef } = props
    const { messages } = useIntl()

    useEffect(() => {
        if (value.routeWatchers == undefined)
            onChange({
                ...value,
                routeWatchers: ''
            })
    }, [value])

    const dropdownOptions = OrderData([
        { selectId: 'RouteDeviation', name: messages['alertsNewAlert_RouteWatchers_RouteDeviation'] },
        //{ selectId: 'StartRoute', name: messages['alertsNewAlert_RouteWatchers_startRoute'] },
        //{ selectId: 'EndRoute', name: messages['alertsNewAlert_RouteWatchers_endRoute'] },
    ], 'name');

    return (
        
        <Form ref={formRef} >
            <Select
                label={messages['alertsNewAlert_Event']}
                requiredMessage={messages['required_field']}
                value={ dropdownOptions.filter((item) => value?.routeWatchers?.includes(item?.selectId))  || []}
                placeholder={messages['alertsNewAlert_SelectPlaceholder']}
                onChange={(selected) => {
                    onChange({ ...value, routeWatchers: selected?.map((element) => element?.selectId) || '' })
                }}
                id="id"
                options={dropdownOptions}
                textField="name"
                valueField="selectId"
                required
                multiple 
                isChips
            />
        </Form>
    );
}